export let allNav = [{
        path: '/dashboard',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/Dashboard.vue'),
        meta: {
            title: '系统首页'
        }
    },
    { // 保险中心-案件列表
        path: '/inseranceLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/getInsurance/inseranceLists.vue'),
        meta: {
            title: '案件列表'
        }
    },
    // {
    //     //在活动模块下  不要了，现在都用延误险呢
    //     path: '/waitLess',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/consumer/waitLess.vue'),
    //     meta: {
    //         title: '等待减免'
    //     }
    // },
    {
        //在活动模块下 原渠道码统计
        path: '/statisticPromotion',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statisticPromotion/statisticPromotion.vue'),
        meta: {
            title: '投放统计'
        }
    },
    {
        //在活动模块下 原二维码列表，渠道码列表
        path: '/promotionQRLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statisticPromotion/promotionQRLists.vue'),
        meta: {
            title: '投放管理'
        }
    },
    {
        //在活动模块下
        path: '/promotionCategoryLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statisticPromotion/promotionCategoryLists.vue'),
        meta: {
            title: '投放类目'
        }
    },

    {
        //在活动模块下
        path: '/promotionLabelLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statisticPromotion/promotionLabelLists.vue'),
        meta: {
            title: '标签列表'
        }
    },
    {
        //在活动模块下
        path: '/offineCard',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/offlinediscountcard/offineCard.vue'),
        meta: {
            title: '线下优惠卡'
        }
    },
    {
        //在活动模块下
        path: '/offineCardLog',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/offlinediscountcard/offineCardLog.vue'),
        meta: {
            title: '优惠卡日志'
        }
    },


    {
        //在活动模块下
        path: '/CooperateWine',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/cooperatewine/cooperateWineLists.vue'),
        meta: {
            title: '权益合作'
        }
    },

    {
        //在乘客模块下
        path: '/dynamicMarkup',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/dynamicmarkup/dynamicMarkupLists.vue'),
        meta: {
            title: '动态加价'
        }
    },
    {
        //酒类预售订单列表
        path: '/liquorsaleorder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/Liquorsaleorder/getLiquorSaleOrderList.vue'),
        meta: {
            title: '酒类预售订单列表'
        }
    },
    {
        path: '/balanceFrozen',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/balanceFrozen.vue'),
        meta: {
            title: '本周冻结金额'
        }
    },
    {
        path: '/NouNouInvoice',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/NouNouInvoice.vue'),
        meta: {
            title: '诺诺网发票'
        }
    },
    {
        path: '/getFinancialAmount',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/getFinancialAmount.vue'),
        meta: {
            title: '财务打款对账'
        }
    },
    {
        path: '/openApiList',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/openapi/openApiList.vue'),
        meta: {
            title: '合作商'
        }
    },

    {
        path: '/zhongQiu',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/zhongQiu/zhongQiu.vue'),
        meta: {
            title: '中秋活动'
        }
    },
    {
        path: '/serviceDriverFeeExcel',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/serviceFee/getCityplatformFee/getCityplatformFee.vue'),
        meta: {
            title: '订单抽成统计'
        }
    },
    {
        path: '/serviceFeeLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/serviceFee/serviceFeeLists.vue'),
        meta: {
            title: '城市服务费'
        }
    },
    // {
    // 去掉这个模块，挪到了城市服务费模块下面
    //     path: '/serviceFeeLogLists',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/serviceFee/serviceFeeLogLists.vue'),
    //     meta: {
    //         title: '城市服务费记录列表'
    //     }
    // },
    {
        path: '/serviceFeeLogDriverLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/serviceFee/serviceFeeLogDriverLists.vue'),
        meta: {
            title: '司机服务费记录列表'
        }
    },
    {
        path: '/getDriverServerFee',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/serviceFee/getDriverServerFee.vue'),
        meta: {
            title: '获取当前城市司机服务费金额'
        }
    },
    {
        path: '/payMode',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/payMode/payModeList.vue'),
        meta: {
            title: '司机抽成'
        }
    },

    {
        path: '/orderModeDeductionLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/payMode/orderModeDeductionLists.vue'),
        meta: {
            title: '订单模式抽成'
        }
    },
    {
        path: '/returnfee',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/returnfee/returnfeeLists.vue'),
        meta: {
            title: '返程费'
        }
    },
    {
        path: '/workPlateList',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/workPlate/workPlateList.vue'),
        meta: {
            title: '司机推广码（工牌）'
        }
    },
    { //在司机模块下
        path: '/driverPreOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverPreOrder/getPreOrderConf.vue'),
        meta: {
            title: '司机预接下一单'
        }
    },
    {
        //在司机模块下
        path: '/driverOnlineTime',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverOnlineTime/driverOnlineTime.vue'),
        meta: {
            title: '在线时长'
        }
    },
    // {
    //     path: '/driverOnline',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverOnline.vue'),
    //     meta: {
    //         title: '司机在线时长'
    //     }
    // },
    { //在司机模块下
        path: '/cutfail',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/cutfail/failLists.vue'),
        meta: {
            title: '扣款失败'
        }
    },

    {
        path: '/business',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/business/businessList.vue'),
        meta: {
            title: '商家合作'
        }
    },
    { // 活动-司机加速包
        path: '/delayReduction',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/delayReduction/delayReduction.vue'),
        meta: {
            title: '司机加速包'
        }
    },
    {
        path: '/fuliguan',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/fuliguan/fuliguan.vue'),
        meta: {
            title: '福利官'
        }
    },

    {
        path: '/hanfu',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/hanfu/hanfu.vue'),
        meta: {
            title: '汉服'
        }
    },
    {
        path: '/businessWalletCash',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/business/businessCashLists/businessWalletCash.vue'),
        meta: {
            title: '商家提现'
        }
    },
    {
        path: '/inviteCode',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/inviteCode/inviteCodeLists.vue'),
        meta: {
            title: '司机邀请拉新'
        }
    },
    {
        path: '/inviteDriverCode',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/inviteDriverCode/inviteDriverCodeList.vue'),
        meta: {
            title: '扫司机工牌码拉新'
        }
    },
    {
        path: '/cashierApplyLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/easyCashier/cashierApplyLists.vue'),
        meta: {
            title: '进件信息管理'
        }
    },
    { // 企业管理-创建企业
        path: '/addStore',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/store/storeLists.vue'),
        meta: {
            title: '创建企业'
        }
    },
    {
        path: '/storeOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/store/storeOrder.vue'),
        meta: {
            title: '企业订单'
        }
    },
    {
        path: '/exportStoreOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/store/exportStoreOrder.vue'),
        meta: {
            title: '订单导出'
        }
    },
    {
        path: '/storeClientList',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/store/storeClientList.vue'),
        meta: {
            title: '客户列表'
        }
    },
    {
        path: '/customerRechargeManage',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/operationsCenterAdmin/customerRechargeManage/customerRechargeManage.vue'),
        meta: {
            title: '客户充值管理'
        }
    },
    {
        path: '/Card',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/card/cardLists.vue'),
        meta: {
            title: '畅行卡  '
        }
    },

    {
        path: '/purchaseHistory',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/purchaseHistory/purchaseHistoryLists.vue'),
        meta: {
            title: '购买记录'
        }
    },

    {
        path: '/usagRecord',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/usagRecord/usagRecordLists.vue'),
        meta: {
            title: '使用记录'
        }
    },

    {
        path: '/getDriverwalletCSV',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/getDriverwalletCSV.vue'),
        meta: {
            title: '司机钱包导出'
        }
    },
    {
        path: '/inspectionLineLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/inspectionline/inspectionLineLists.vue'),
        meta: {
            title: '检车线管理'
        }
    },
    { // 检车线-检车线订单
        path: '/inspectionLineOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/inspectionLineOrder/inspectionLineOrder.vue'),
        meta: {
            title: '检车线订单'
        }
    },
    {
        path: '/activeLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/active/activeLists.vue'),
        meta: {
            title: '轮播活动'
        }
    },
    {
        path: '/activeLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/active/activeLists.vue'),
        meta: {
            title: '轮播活动'
        }
    },
    {
        path: '/prizeList',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/prize/prizeLists.vue'),
        meta: {
            title: '奖品列表'
        }
    },
    {
        path: '/prizeRecord',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/prize/prizeRecord.vue'),
        meta: {
            title: '中奖记录'
        }
    },

    {
        path: '/activityLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/groupactivity/activityLists.vue'),
        meta: {
            title: '活动列表'
        }
    },
    {
        path: '/groupLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/groupactivity/groupLists.vue'),
        meta: {
            title: '组队列表'
        }
    },

    // { 暂时没用隐藏掉
    //     path: '/lacaraRecordList',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/driver/lacaraRecordList.vue'),
    //     meta: {
    //         title: '拉卡拉提现'
    //     }
    // },
    {
        path: '/orderConnectLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderConnect/orderConnectLists.vue'),
        meta: {
            title: '连单活动列表'
        }
    },
    // { // 跑腿-闪送订单 暂时不用，隐藏
    //     path: '/shansongOrderLists',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/legwork/shansong/shansongOrderLists.vue'),
    //     meta: {
    //         title: '闪送跑腿订单'
    //     }
    // },
    // { // 跑腿-UU跑腿订单 暂时不用，隐藏
    //     path: '/UUOrderLists',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/legwork/UUorder/UUOrderLists.vue'),
    //     meta: {
    //         title: 'UU跑腿订单'
    //     }
    // },
    // { // 跑腿-达达订单 暂时不用，隐藏
    //     path: '/dadaOrderLists',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/legwork/DADAorder/dadaOrderLists.vue'),
    //     meta: {
    //         title: '达达订单列表'
    //     }
    // },
    // { // 跑腿-达达门店 暂时不用，隐藏
    //     path: '/dadaShopLists',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/legwork/DADAorder/shopList/dadaShopLists.vue'),
    //     meta: {
    //         title: '达达门店管理'
    //     }
    // },
    // { // 跑腿-跑腿订单 暂时不用，隐藏
    //     path: '/legworkOrder',
    //     component: () =>
    //         import ( /* webpackChunkName: "donate" */ '@/components/page/legwork/order/legworkOrder.vue'),
    //     meta: {
    //         title: '跑腿订单'
    //     }

    // },
    // { // 跑腿-订单模式 暂时不用，隐藏
    //     path: '/legworkMode',
    //     component: () =>
    //         import ( /* webpackChunkName: "donate" */ '@/components/page/legwork/mode/legworkMode.vue'),
    //     meta: {
    //         title: '订单模式'
    //     }

    // },
    // { // 跑腿-配置 暂时不用，隐藏
    //     path: '/legworkSetUp',
    //     component: () =>
    //         import ( /* webpackChunkName: "donate" */ '@/components/page/legwork/setUp/legworkSetUp.vue'),
    //     meta: {
    //         title: '公斤配置'
    //     }

    // },
    {
        path: '/driverOrderConnectRecordLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderConnect/driverOrderConnectRecordLists.vue'),
        meta: {
            title: '连单奖励列表'
        }
    },
    {
        path: '/adminRoleLists',
        component: () =>
            import ( /* webpackChunkName: "donate" */ '@/components/page/system/adminRoleLists.vue'),
        meta: {
            title: '客服角色'
        }
    },
    {
        path: '/confLists',
        component: () =>
            import ( /* webpackChunkName: "donate" */ '@/components/page/conf/confLists.vue'),
        meta: {
            title: '配置微调(专业)'
        }

    },

    {
        path: '/adminList',
        component: () =>
            import ( /* webpackChunkName: "donate" */ '@/components/page/admin/adminList.vue'),
        meta: {
            title: '客服(管理员)'
        }

    },


    {
        path: '/labelLists',
        component: () =>
            import ( /* webpackChunkName: "donate" */ '@/components/page/label/labelLists.vue'),
        meta: {
            title: '标签管理'
        }

    },
    {
        path: '/couponType',
        component: () =>
            import ( /* webpackChunkName: "donate" */ '@/components/page/coupon/couponType/couponType.vue'),
        meta: {
            title: '优惠券类型'
        }
    },
    {
        path: '/couponLists',
        component: () =>
            import ( /* webpackChunkName: "donate" */ '@/components/page/coupon/couponLists/couponLists.vue'),
        meta: {
            title: '优惠券列表'
        }
    },
    {
        path: '/couponRecordLists',
        component: () =>
            import ( /* webpackChunkName: "donate" */ '@/components/page/coupon/couponRecordLists/couponRecordLists.vue'),
        meta: {
            title: '优惠券日志'
        }
    },


    {
        path: '/msgCountDetails',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/city/msgCountDetails.vue'),
        meta: {
            title: '短信详情'
        }
    },

    {
        path: '/privateNumber',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/city/privateNumber.vue'),
        meta: {
            title: '隐私通话'
        }
    },

    {
        path: '/voiceNumberCity',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/city/voiceNumberCity.vue'),
        meta: {
            title: '语音通知'
        }
    },

    {
        path: '/cityDetails',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/city/cityDetails.vue'),
        meta: {
            title: '城市详情'
        }
    },
    {
        path: '/driver',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driver.vue'),
        meta: {
            title: '司机管理'
        }
    },
    {
        path: '/manDriver',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/manDriver.vue'),
        meta: {
            title: '司机管理'
        }
    },
    {
        path: '/driverPoints',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverPoints.vue'),
        meta: {
            title: '司机分数'
        }
    },
    {
        path: '/priority',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/priority/priorityLists.vue'),
        meta: {
            title: '优享券'
        }
    },
    // { // 原司机任务 暂时不用，隐藏掉
    //     path: '/taskLists',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/driver/task/taskLists.vue'),
    //     meta: {
    //         title: '司机任务'
    //     }
    // },
    { // 新司机任务模块
        path: '/taskNewLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/taskNew/taskNewLists.vue'),
        meta: {
            title: '司机任务'
        }
    },
    {
        path: '/orderAssessList',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/orderAssessList/orderAssessList.vue'),
        meta: {
            title: '评价列表'
        }
    },
    {
        path: '/driverRecruit',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverRecruit/driverRecruit.vue'),
        meta: {
            title: '招募司机'
        }
    },
    {
        path: '/driverDan',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverDan/driverDan.vue'),
        meta: {
            title: '司机段位'
        }
    },
    {
        path: '/positioningReward',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/positioningReward/positioningReward.vue'),
        meta: {
            title: '定位红包'
        }
    },

    {
        path: '/cityTeam',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/city/cityTeam.vue'),
        meta: {
            title: '城市小组'
        }
    },
    {
        path: '/huifu',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/city/huifu/huifu.vue'),
        meta: {
            title: '汇付账户'
        }
    },
    {
        path: '/driverAlert',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/city/driverAlert/driverAlert.vue'),
        meta: {
            title: '司机预警'
        }
    },
    {
        path: '/getPerformanceCSV',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/getPerformanceCSV.vue'),
        meta: {
            title: '司机业绩导出'
        }
    },
    {
        path: '/getDriverTrueCSV',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/getDriverTrueCSV.vue'),
        meta: {
            title: '有效司机导出'
        }
    },

    {
        path: '/driverBankCard',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverBankCard/driverBankCard.vue'),
        meta: {
            title: '绑卡信息'
        }
    },
    {
        path: '/driverWalletCash',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverWalletCash/driverWalletCash.vue'),
        meta: {
            title: '提现审核'
        }
    },
    {
        path: '/driverCash2LeaveLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverCash2LeaveLists/driverCash2LeaveLists.vue'),
        meta: {
            title: '解约提现审核'
        }
    },
    {
        path: '/determine',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/determine/determine.vue'),
        meta: {
            title: '签约审核'
        }
    },
    {
        path: '/signingRules',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/signingRules/signingRules.vue'),
        meta: {
            title: '签约规则'
        }
    },
    {
        path: '/driverSigningRules',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driversign/driverSigningRules.vue'),
        meta: {
            title: '签约规则新'
        }
    },
    {
        path: '/signingMonthPreferential',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/signingMonthPreferential/signingMonthPreferentialLists.vue'),
        meta: {
            title: '自然月签约优惠'
        }
    },
    {
        path: '/signingPreferential',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/signingPreferential/signingPreferential.vue'),
        meta: {
            title: '签约优惠'
        }
    },
    {
        path: '/adminJournal',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/adminJournal/adminJournal.vue'),
        meta: {
            title: '管理员日志'
        }
    },
    {
        path: '/driverJournal',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driverJournal/driverJournal.vue'),
        meta: {
            title: '司机日志'
        }
    },
    {
        path: '/pushJournal',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/pushJournal/pushJournal.vue'),
        meta: {
            title: '推送日志'
        }
    },
    {
        path: '/userJournal',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/userJournal/userJournal.vue'),
        meta: {
            title: '用户日志'
        }
    },
    {
        path: '/user',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/user.vue'),
        meta: {
            title: '乘客信息'
        }
    },
    // {
    //     path: '/eBusDownloadStatement',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/user/eBusDownloadStatement.vue'),
    //     meta: {
    //         title: '农行账单'
    //     }
    // },
    {
        path: '/userExport',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/userExport.vue'),
        meta: {
            title: '乘客信息导出'
        }
    },
    {
        path: '/userBankCard',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/userBankCard/userBankCard.vue'),
        meta: {
            title: '乘客银行卡'
        }
    },
    {
        path: '/userWalletCash',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/userWalletCash/userWalletCash.vue'),
        meta: {
            title: '乘客提现'
        }
    },
    {
        path: '/userBill',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/userBill.vue'),
        meta: {
            title: '乘客账单'
        }
    },
    {
        path: '/demandLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/demandLists/demandLists.vue'),
        meta: {
            title: '用户订单需求'
        }
    },
    {
        path: '/userBankCard',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/userBankCard/userBankCard.vue'),
        meta: {
            title: '乘客绑卡'
        }
    },
    {
        path: '/userWalletCash',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/userWalletCash/userWalletCash.vue'),
        meta: {
            title: '提现审核'
        }
    },
    {
        path: '/advertInformation',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/advert/advertInformation/advertInformation.vue'),
        meta: {
            title: '广告库'
        }
    },
    {
        path: '/advertAppoint',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/advert/advertAppoint/advertAppoint.vue'),
        meta: {
            title: '广告位'
        }
    },
    {
        path: '/article',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/article/article.vue'),
        meta: {
            title: '发公告'
        }
    },
    { // 原订单监控
        path: '/substituteDrivingOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/substituteDrivingOrder/substituteDrivingOrder.vue'),
        meta: {
            title: '订单管理'
        }
    },
    { // 原订单监控
        path: '/manDrivingOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/substituteDrivingOrder/manDrivingOrder.vue'),
        meta: {
            title: '男司机订单管理'
        }
    },
    { // 订单-服务中订单
        path: '/ServiceOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/ServiceOrder.vue'),
        meta: {
            title: '服务中订单'
        }
    },
    { //
        path: '/MemberDayOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/substituteDrivingOrder/MemberDayOrder.vue'),
        meta: {
            title: '会员日订单'
        }
    },
    {
        path: '/overspeed',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/overspeed/overspeed.vue'),
        meta: {
            title: '超速记录'
        }
    },
    {
        //在订单模块下
        path: '/advancepayment',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/advancePaymentSub/advancePaymentSub.vue'),
        meta: {
            title: '预付款'
        }
    },

    {
        path: '/orderHistory',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/substituteDrivingOrder/orderHistory.vue'),
        meta: {
            title: '历史订单'
        }
    },
    {
        path: '/orderPdLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/substituteDrivingOrder/orderPdLists.vue'),
        meta: {
            title: '订单指派'
        }
    },
    { // 订单管理-订单查看
        path: '/orderView',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/orderView.vue'),
        meta: {
            title: '订单查看'
        }
    },
    {
        path: '/orderInvoice',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/orderInvoice.vue'),
        meta: {
            title: '订单发票'
        }
    },
    {
        path: '/orderExport',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/orderExport/orderExport.vue'),
        meta: {
            title: '订单导出'
        }
    },
    {
        path: '/historyOrderExport',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderManagement/orderExport/historyOrderExport.vue'),
        meta: {
            title: '历史订单导出'
        }
    },
    {
        path: '/inspectionLineOrderCSV',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/inspectionLineOrder/inspectionLineOrderCSV.vue'),
        meta: {
            title: '检车订单导出'
        }
    },

    {
        path: '/recommendAddress',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/recommendAddress/recommendAddress.vue'),
        meta: {
            title: '推荐地址(广告)'
        }
    },


    {
        path: '/synchronization',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/synchronization.vue'),
        meta: {
            title: '同步缓存(专业)'
        }
    },
    {
        path: '/orderStatistics',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/orderStatistics.vue'),
        meta: {
            title: '订单统计'
        }
    },
    {
        path: '/statisticOrder',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/order.vue'),
        meta: {
            title: '订单统计表格'
        }
    },
    {
        path: '/statisticDriver',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/driver.vue'),
        meta: {
            title: '司机统计表格'
        }
    },
    {
        path: '/driverScancodeLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverScancodeLists.vue'),
        meta: {
            title: '司机推荐列表'
        }
    },
    {
        path: '/driverRecharge',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverRecharge.vue'),
        meta: {
            title: '司机充值记录'
        }
    },
    {
        path: '/statisticConsumer',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/consumer.vue'),
        meta: {
            title: '用户统计表格'
        }
    },
    {
        path: '/consumerTripleRecordLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/consumerTripleRecordLists.vue'),
        meta: {
            title: '三倍充值统计'
        }
    },
    {
        path: '/consumerStatistics',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/consumerStatistics.vue'),
        meta: {
            title: '乘客统计'
        }
    },
    {
        path: '/consumerRecharge',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/consumerRecharge.vue'),
        meta: {
            title: '乘客充值记录'
        }
    },
    {
        path: '/consumerScancodeLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/user/consumerScancodeLists.vue'),
        meta: {
            title: '乘客奖励金'
        }
    },

    {
        path: '/driverStatistics',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/driverStatistics.vue'),
        meta: {
            title: '司机统计'
        }
    },
    {
        path: '/driverDriverStatusLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/driverDriverStatusLists.vue'),
        meta: {
            title: '在线时长统计'
        }
    },
    {
        path: '/apiVisit',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/apiVisit.vue'),
        meta: {
            title: '接口访问统计'
        }
    },
    {
        path: '/getOrderCouponLists',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/getOrderCouponLists.vue'),
        meta: {
            title: '使用优惠券统计'
        }
    },
    {
        path: '/help',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/help/help.vue'),
        meta: {
            title: '使用帮助'
        }
    },
    {
        path: '/useCourse',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/useCourse.vue'),
        meta: {
            title: '使用教程'
        }
    },
    // {
    //     path: '/driverPromote',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverPromote/driverPromote.vue'),
    //     meta: {
    //         title: '司机推广'
    //     }
    // },
    { // 线下推广 任务列表
        path: '/offlinePromotionList',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/Offlinepromotion/offlinePromotionList.vue'),
        meta: {
            title: '任务列表'
        }
    },
    {
        path: '/examineDriverPromote',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/examineDriverPromote/examineDriverPromote.vue'),
        meta: {
            title: '推广审核'
        }
    },
    {
        path: '/bugManagement',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/bugManagement/bugManagement.vue'),
        meta: {
            title: '建议管理'
        }
    },
    {
        path: '/partner',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/partner/partner.vue'),
        meta: {
            title: '合作伙伴'
        }
    },
    {
        path: '/problem',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/problem/problem.vue'),
        meta: {
            title: '常见问题'
        }
    },
    {
        path: '/wechat',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/wechat/wechat.vue'),
        meta: {
            title: '微信支付'
        }
    },
    {
        path: '/alipay',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/alipay/alipay.vue'),
        meta: {
            title: '支付宝'
        }
    },
    {
        path: '/group',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/group/group.vue'),
        meta: {
            title: '集团'
        }
    },
    {
        path: '/thirdAccount',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/cooperatewine/thirdAccount/thirdAccount.vue'),
        meta: {
            title: '三方账户'
        }
    },
    {
        path: '/InspectionCard',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/InspectionCard.vue'),
        meta: {
            title: '检车卡列表'
        }
    },
    {
        path: '/driverCount',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/driverCount.vue'),
        meta: {
            title: '司机今日排行'
        }
    },
    {
        path: '/ipcShopping',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/ipcShopping/ipcShopping.vue'),
        meta: {
            title: '异业联盟'
        }
    },
    {
        path: '/consumerReward',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/consumerReward/consumerReward.vue'),
        meta: {
            title: '乘客分享'
        }
    },
    {
        path: '/pingan',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/pingan/pingan.vue'),
        meta: {
            title: '平安发卡账号管理'
        }
    },
    {
        path: '/consumerOrderStatistics',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/consumerOrderStatistics.vue'),
        meta: {
            title: '乘客下单统计'
        }
    },

    {
        path: '/walletkey',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/walletkey/walletkey.vue'),
        meta: {
            title: '现金券列表'
        }
    },
    {
        path: '/walletkeylog',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/walletkey/walletkeylog.vue'),
        meta: {
            title: '领取日志'
        }
    },

    { // 九州优惠卡-优惠卡列表
        path: '/discountCard',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/discountCard/discountCardList.vue'),
        meta: {
            title: '优惠卡列表'
        }
    },
    {
        path: '/discountCardLog',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/discountCard/discountCardLog.vue'),
        meta: {
            title: '领取日志'
        }
    },

    {
        path: '/orderModel',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderModel/orderModel.vue'),
        meta: {
            title: '订单模式'
        }
    },
    {
        path: '/timePackage',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderModel/timePackage.vue'),
        meta: {
            title: '时间套餐包'
        }
    },
    {
        path: '/taxiRule',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/orderModel/taxiRule.vue'),
        meta: {
            title: '打车费配置'
        }
    },
    // { // 暂时不用  隐藏
    //     path: '/legworkProtect',
    //     component: () =>
    //         import ( /* webpackChunkName: "city" */ '@/components/page/legwork/legworkProtect/legworkProtect.vue'),
    //     meta: {
    //         title: '保价金配置'
    //     }
    // },
    {
        path: '/driverIncomeCount',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/driverIncomeCount.vue'),
        meta: {
            title: '司机收入'
        }
    },
    {
        path: '/getConsumerRechargeDetail',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/getConsumerRechargeDetail.vue'),
        meta: {
            title: '用户充值'
        }
    },
    {
        path: '/getDriverRechargeDetail',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/statistics/getDriverRechargeDetail.vue'),
        meta: {
            title: '司机充值'
        }
    },
    {
        path: '/driverSales',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/driver/driverSales.vue'),
        meta: {
            title: '销单管理'
        }
    },
    {
        path: '/couponPackage',
        component: () =>
            import ( /* webpackChunkName: "city" */ '@/components/page/couponPackage/couponPackageList.vue'),
        meta: {
            title: '渠道优惠券礼包'
        }
    },
    {
        path: '/couponPackageReceiveLists',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/couponPackage/couponPackageReceiveLists.vue'),
        meta: {
            title: '领取记录'
        }
    }, {
        path: '/tmallorder',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/orderManagement/tmallorder/tmallorder.vue'),
        meta: {
            title: '天猫联运订单'
        }
    }, { // 机器人-群列表
        path: '/Machine',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/Machine/Machine.vue'),
        meta: {
            title: '群列表'
        }
    },


    {
        //九州合作服务商-转派订单列表
        path: '/serviceOrderLists',
        component: () =>
            import ('@/components/page/service/serviceOrderLists.vue'),
        meta: {

            title: '转派订单列表'

        }
    },
    { // 合伙人设置
        path: '/distributionConfig',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/distributionConfig/distributionConfig.vue'),
        meta: {
            title: '合伙人设置'
        }
    },
    { // 合伙人数据
        path: '/distributionPromoterLists',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/distributionConfig/heHuoRen/distributionPromoterLists.vue'),
        meta: {
            title: '合伙人数据'
        }
    },

    { // 合伙人审核distributionWithdrawLists
        path: '/distributionWithdrawLists',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/distributionConfig/shenHe/distributionWithdrawLists.vue'),
        meta: {
            title: '合伙人审核'
        }
    },
    { // 提现审核
        path: '/withdraw',
        component: () =>
            import ( /* webpackChunkName: "dashboard" */ '@/components/page/distributionConfig/tiXianShenHe/withdraw.vue'),
        meta: {
            title: '提现审核'
        }
    },

];